import React, { Component, Fragment } from "react";
import { INVALID_MESSAGE } from "../../constant";
import { getScodeRedirectAPI } from "../../APIs";

export default class ViewDocumentShortCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shortCode: null,
      OTPMessage: { type: '', text: '' }
    };
    this.isEffectRun = false; // Guard to prevent duplicate calls
  }

  componentDidMount() {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');
    const shortCode = parts.length ? parts.slice(-1)[0] : null;

    if (shortCode && !this.isEffectRun) {
      this.getScodeRedirectData(shortCode);
      this.isEffectRun = true; // Mark as executed
      this.setState({ shortCode });
    }
  }

  getScodeRedirectData = async (shortCode) => {
    try {
      if (shortCode) {
        let apiRes = await getScodeRedirectAPI({ scode: shortCode });
        if (apiRes.status === 200 && apiRes.data.statusCode === 200 && Object.keys(apiRes?.data).length) {
          window.location.href = apiRes.data.redirect_url;
        }
        else { this.setState({ OTPMessage: { type: 'error', text: apiRes?.data?.message } }); }
      } else {
        this.setState({ OTPMessage: { type: 'error', text: INVALID_MESSAGE } });
      }
    }
    catch (err) {
      console.log('get-scode-redirect-err:', err);
      this.setState({ OTPMessage: { type: 'error', text: INVALID_MESSAGE } });
    }
  };

  render() {
    const { OTPMessage } = this.state;

    return (
      <Fragment>
        {OTPMessage.text && (
          <div className="d-flex justify-content-center align-items-center vh-100">
            {/* <form className="p-4 border rounded" style={{ width: '400px' }}> */}
            {/* <img className="mx-auto d-block mb-4" src={Logo} alt="myhealthcare logo"></img> */}
            {<div role="alert" className={`alert ${OTPMessage.type === 'error' ? 'alert-danger' : OTPMessage.type === 'success' ? 'alert-success' : 'alert-info'}`}>{OTPMessage.text}</div>}
            {/* </form> */}
          </div>
        )}
      </Fragment>
    );
  }
}